import { render, staticRenderFns } from "./BusinessColumnChannel.vue?vue&type=template&id=8da0c6ca&scoped=true"
import script from "./BusinessColumnChannel.vue?vue&type=script&lang=js"
export * from "./BusinessColumnChannel.vue?vue&type=script&lang=js"
import style0 from "./BusinessColumnChannel.vue?vue&type=style&index=0&id=8da0c6ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da0c6ca",
  null
  
)

export default component.exports